<template>
  <div class="box">
    <div id="header">
      <div class="logo"><img src="../assets/images/20180102/logo@2x.png"/></div>
      <el-nav></el-nav>
    </div>
  </div>
</template>

<script>
  import elNav from './Nav'
  export default {
    name: 'header',
    components: {
      elNav
    }
  }
</script>

<style lang="scss">
  .box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 0.8rem;
    z-index: 999;
    background: #fff;
    padding-top: .1rem;
    min-width: 1300px;
    @media screen and (max-width: 760px) {
      min-width: 0;
    }
  }
  #header {
    font-size: 0.1rem;
    /*opacity: 0.8;*/
    width: 88.273vw;
    margin: 0 auto;
    position: relative;
    min-width: 1200px;
    @media screen and (max-width: 760px) {
      width: auto;
      min-width: 0;
    }
    .logo {
      width: 1.09rem;
      height: .28rem;
      position: absolute;
      top: 0.15rem;
      left: 1.5rem;
      @media screen and (max-width: 1700px) {
        left: .5rem;
        @media screen and (max-width: 760px) {
          left: .1rem;
        }
      }
      img {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Header.vue?51ea2217